module.exports = __webpack_public_path__ + "static/media/intro_1.260c34f9.svg";